import { useState } from 'react';
import { Container, Grid, Button, FormControlLabel, Checkbox } from '@mui/material';
import { TextField } from '../../style-guide';
import PredefinedDataSettingsList from './PredefinedDataSettingsList';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { REQUEST_ACTIONS, sendRequest } from 'utils/Communicator';
import { snackbarToggle } from 'reducers/snackbarSlicer';
import {
  onAirPolDataChange,
  onAirPoaDataChange,
  onCountryOfOriginDataChange,
  onFileCodesChange,
  onIncotermsDataChange,
  onSubModeDataChange,
  onDisableBlinkChange,
} from 'reducers/order-reducers/predefinedDataSlicer';
import * as XLSX from 'xlsx';
import { onTruckingModeDataChange } from 'reducers/stage-reducers/truckingStageSlicer';

const PredefinedDataSettings = ({ loginUser }) => {
  const dispatch = useDispatch();
  const { incotermsData, subModeData, countryOfOriginData, airPolData, airPoaData, lclPolData, lclPoaData, fileCodes, disableBlink } =
    useSelector(state => state.predefinedData);

  const { truckingModeData } = useSelector(state => state.truckingStage);

  const [poaShippingModeId, setPoaShippingModeId] = useState(1);
  const [polShippingModeId, setPolShippingModeId] = useState(1);
  const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);

    const onReloadFiles = () => {
        //sendRequest(`/api/fa/setDepartureStages`, REQUEST_ACTIONS.POST, {}, { 
        //sendRequest(`/api/fa/setOrderStage`, REQUEST_ACTIONS.POST, {}, {
        //sendRequest(`/api/fa/setOrderChat`, REQUEST_ACTIONS.POST, {}, {
        sendRequest(`/api/fa/removeSeenChat`, REQUEST_ACTIONS.POST, {}, {
            successCallback: response => {
                if (response === "SUCCESS")
                    dispatch(snackbarToggle({ type: 'success', message: "setDepartureStages was sent successfully." }));
                else
                    dispatch(snackbarToggle({ type: 'error', message: "setDepartureStages not successful: " + response }));
            },
            failedCallback,
        });
    }
    const onReloadFiles1 = () => {
        //sendRequest(`/api/fa/setDepartureStages`, REQUEST_ACTIONS.POST, {}, {
        //sendRequest(`/api/fa/setOrderStage`, REQUEST_ACTIONS.POST, {}, {
        //sendRequest(`/api/fa/removeSeenChat`, REQUEST_ACTIONS.POST, {}, {
        sendRequest(`/api/fa/setOrderChat`, REQUEST_ACTIONS.POST, {}, {
            successCallback: response => {
                if (response === "SUCCESS")
                    dispatch(snackbarToggle({ type: 'success', message: "setDepartureStages was sent successfully." }));
                else
                    dispatch(snackbarToggle({ type: 'error', message: "setDepartureStages not successful: " + response }));
            },
            failedCallback,
        });
    }
    const jsonToExcel = function (data, data1, name, header) {
        var ws = XLSX.utils.json_to_sheet(data, header);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "All");
        var ws1 = XLSX.utils.json_to_sheet(data1, header);
        XLSX.utils.book_append_sheet(wb, ws1, "Errors");
        XLSX.writeFile(wb, name + ".xlsx");
    }
    const [notificationStatus, setNotificationStatus] = useState(loginUser.reminderStatus);
    const [notificationEmail, setNotificationEmail] = useState(loginUser.reminderMail);

    useEffect(() => {
        sendRequest(`/api/user/1`, REQUEST_ACTIONS.GET, '', {
            successCallback: message => {
                setNotificationStatus(message.reminderStatus)
                setNotificationEmail(message.reminderMail)
                console.log(message)
            },
            failedCallback,
        });
    }, [loginUser]);
    const saveNotificationSettings = () => {
        sendRequest(`/api/users/updateReminderData/1?status=${notificationStatus}&mail=${notificationEmail}`, REQUEST_ACTIONS.PUT, '', {
            successCallback: message => {
            },
            failedCallback,
        });
    };
    const onSinayCSV = () => {
        sendRequest(`/api/fa/getStatusCSV`, REQUEST_ACTIONS.GET, '', {
            successCallback: message => {
                var datas = message.split("\n#######");
                var lines = datas[0].split("\n");
                var lines_non = datas[1].split("\n");
                var data_main = [];
                var data_non = [];
                var header = ["Date", "Job Number", "Container Number", "Status"];
                for (var i = 0; i < lines.length; i++) {
                    var ln = lines[i].split("####");
                    if (ln[0] && ln[10]) {
                        var ln10 = ["SUCCESS", "", "", "", ""]
                        if (ln[10]) {
                            if (ln[10].includes(";")) {
                                ln10 = ln[10].split(";");
                            } else {
                                ln10[0] = ln[10];
                            }
                        }
                        var data = {
                            "Date": new Date(ln[0]),
                            "Creation Date": new Date(ln[1]),
                            "Job Number": ln[2],
                            "Scac": ln[7],
                            "ScacNew": (ln[8] === "NULL" ? "" : ln[8]),
                            "Container Number": ln[3],
                            "Consignee": ln[4],
                            "ETD": new Date(Number(ln[5])),
                            "ETA": new Date(Number(ln[6])),
                            "Port Changed": (ln[9] != 0 ? new Date(Number(ln[9])) : "-"),
                            "Status": ln10[0],
                            "API1": ln10[1],
                            "Result1": ln10[2],
                            "API2": ln10[3],
                            "Result2": ln10[4]
                        };
                        if (ln.length == 12) {
                            data["Incoterms"] = incotermsData.find(inco => inco.id == ln[11]).name || '-';
                            if (ln[11] == 2) {
                                data["Status"] = "Sinay not called";
                                continue;
                            }
                        }
                        data_main.push(data);
                    }
                }
                for (var i = 0; i < lines_non.length; i++) {
                    var ln = lines_non[i].split("####");
                    if (ln[0]) {
                        var data = {
                            "Date": new Date(ln[0]),
                            "Creation Date": new Date(ln[1]),
                            "Job Number": ln[2],
                            "Scac": ln[7],
                            "ScacNew": (ln[8] === "NULL" ? "" : ln[8]),
                            "Container Number": ln[3],
                            "Consignee": ln[4],
                            "ETD": new Date(Number(ln[5])),
                            "ETA": new Date(Number(ln[6])),
                            "Port Changed": (ln[9] != 0 ? new Date(Number(ln[9])) : "-"),
                            "Status": ln[10]
                        };
                        data_non.push(data);
                    }
                }
                jsonToExcel(data_main, data_non, "SinayStatus", header);
            },
            failedCallback,
        });
    }
    
    const onDisableBlinkUpdate = (id, disableBlink) => {
        sendRequest(`/api/users/updateDisableBlinkInd/${id}?disableBlink=${disableBlink}`, REQUEST_ACTIONS.PUT, '', {
            successCallback: message => {
                dispatch(onDisableBlinkChange(disableBlink));
                dispatch(snackbarToggle({ type: 'success', message }));
            },
            failedCallback,
        });
    };

  return (
    <Container maxWidth='xl'>
      <Grid container spacing={2} sx={{pl: '14px'}}>
        <FormControlLabel
              control={
                <Checkbox checked={disableBlink === null? loginUser.disableBlink: disableBlink} onChange={event => {onDisableBlinkUpdate(loginUser.id, event.target.checked);}} />
              }
              label='Disable Blink'
            />
      </Grid>
      <Grid container spacing={2}>
        <PredefinedDataSettingsList
          listData={incotermsData}
          title='Incoterms'
          field='incoterms'
          onFieldChange={onIncotermsDataChange}
        />
        <PredefinedDataSettingsList
          listData={subModeData}
          title='Sub Mode'
          field='subMode'
          onFieldChange={onSubModeDataChange}
        />
        <PredefinedDataSettingsList
          listData={countryOfOriginData}
          title='Country Of Origin'
          field='countryOfOrigin'
          onFieldChange={onCountryOfOriginDataChange}
        />
        <PredefinedDataSettingsList
          listData={truckingModeData}
          title='Trucking Mode'
          field='truckingMode'
          onFieldChange={onTruckingModeDataChange}
        />
        <PredefinedDataSettingsList
          listData={polShippingModeId === 1 ? airPolData : lclPolData}
          title='POL'
          field='pol'
          onFieldChange={onAirPolDataChange}
          shippingModeId={polShippingModeId}
          setShippingModeId={setPolShippingModeId}
        />
        <PredefinedDataSettingsList
          listData={poaShippingModeId === 1 ? airPoaData : lclPoaData}
          title='POD'
          field='poa'
          onFieldChange={onAirPoaDataChange}
          shippingModeId={poaShippingModeId}
          setShippingModeId={setPoaShippingModeId}
        />
        <PredefinedDataSettingsList
          listData={fileCodes}
          title='File codes'
          field='codes'
          onFieldChange={onFileCodesChange}
        />
          </Grid>
          {false && loginUser.fullName === "Admin" && <Button variant='contained' sx={{ mr: 2 }} onClick={onReloadFiles}>
              2nd
          </Button>}
          {false && loginUser.fullName === "Admin" && <Button variant='contained' sx={{ mr: 2 }} onClick={onReloadFiles1}>
              1st
          </Button>}
          {loginUser.fullName === "Admin" && <Button variant='text' onClick={onSinayCSV}>
              Sinay CSV
          </Button>}
          {loginUser.fullName === "Admin" && <Grid item container>
              <TextField
                  sm={9}
                  md={9}
                  lg={9}
                  label='Notification Email'
                  value={notificationEmail}
                  onChange={event => setNotificationEmail(event.target.value)}
              />
              <FormControlLabel style={{ marginLeft: "-2px" }}
                  control={
                      <Checkbox checked={notificationStatus} onChange={event => setNotificationStatus(event.target.checked)} />
                  }
                  label='Notify By Email'
              />
              <Button variant='primary' onClick={saveNotificationSettings}>
                  Save
              </Button>
          </Grid>}
    </Container>
  );
};

export default PredefinedDataSettings;
